module.exports = __webpack_public_path__ + "img/logo.9edd5399.svg";